import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-automatic_trigger",
  "use": "icon-automatic_trigger-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-automatic_trigger\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M12,20a8,8,0,1,1,8-8A8,8,0,0,1,12,20ZM12,5.45A6.55,6.55,0,1,0,18.55,12,6.56,6.56,0,0,0,12,5.45Zm.79,6.77V8.57h-1.6V12.9l3.42,2.53.93-1.24Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol